import { IconName } from '@agilepoint/web-components';
import React, { useCallback } from 'react';
import styled from 'styled-components';
import { FullWidthStackPanel, PREDEFINED_TABLE_STYLES } from './common';
import { useTableFormat } from './table-format-store';
import { Typography } from '../../../../../typography';
import { Icon } from '../../../../../icon';
import { StackPanel } from '../../../../../stack-panel';
import { DefaultButton } from '../../../../../button';
import { IBaseComponentProps } from '../../../../../types';

interface ITileProps extends IBaseComponentProps {
    iconName?: IconName;
    label: string;
    styleName: string;
    onClick(): void;
}

function TileBase(props: ITileProps) {
    const { className, label, iconName, styleName, onClick } = props;
    const { setTableFormat } = useTableFormat();

    const _onClick = useCallback(() => {
        const style = PREDEFINED_TABLE_STYLES.get(styleName);
        if (style) {
            setTableFormat(style);
        }
        onClick();
    }, [onClick, setTableFormat, styleName]);

    return (
        <StackPanel className={className} orientation="vertical" alignment="center" onClick={_onClick}>
            <Icon iconName={iconName} iconSize="80" />
            <Typography.H6>{label}</Typography.H6>
        </StackPanel>
    );
}

const Tile = styled(TileBase)`
    cursor: pointer;
    width: 100px;

    ${Icon} {
        fill: unset;
    }
`;

interface ITableStylesConfigProps {
    onApply(): void;
}

export function TableStylesConfig({ onApply }: ITableStylesConfigProps) {
    const { setTableFormat } = useTableFormat();

    const _clearAll = useCallback(() => {
        const style = PREDEFINED_TABLE_STYLES.get('none');
        if (style) {
            setTableFormat(style);
        }
        onApply();
    }, [onApply, setTableFormat]);

    return (
        <FullWidthStackPanel orientation="vertical">
            <FullWidthStackPanel orientation="horizontal" alignment="flex-end">
                <Tile key="default" label="Default" iconName="ap-default.rte" styleName="default" onClick={onApply} />
                <Tile key="grid" label="Grid" iconName="ap-grid.rte" styleName="grid" onClick={onApply} />
                <Tile key="lines" label="Light Lines" iconName="ap-light-lines.rte" styleName="light-lines" onClick={onApply} />
            </FullWidthStackPanel>
            <FullWidthStackPanel orientation="horizontal" alignment="flex-end">
                <Tile key="tones" label="Two Tones" iconName="ap-two-tones.rte" styleName="two-tones" onClick={onApply} />
                <Tile key="bands" label="Light Bands" iconName="ap-light-bands.rte" styleName="light-bands" onClick={onApply} />
                <DefaultButton label="Clear All" size="small" onClick={_clearAll} />
            </FullWidthStackPanel>
        </FullWidthStackPanel>
    );
}
